import cx from 'classnames';
import React from 'react';
import type { LayoutGapProps } from './LayoutGap';
import { LayoutGap } from './LayoutGap';

export interface FormSideOffsetLayoutProps extends Omit<
	LayoutGapProps,
	'className'
> {
	pl?: number;
	asChild?: boolean;
	className?: string;
}

export const FormSideOffsetLayout = ({
	children,
	gap,
	pl = 8,
	className,
	asChild = false,
}: FormSideOffsetLayoutProps) => {
	const classNames = cx(pl && `pl-${pl}`, className && className);

	const cloneWithMergedClassName = (
		child: React.ReactElement,
		extraClassName?: string
	) => {
		const existing = (child.props as { className?: string }).className;
		return React.cloneElement(
			child as React.ReactElement<{ className?: string }>,
			{
				className: cx(existing, extraClassName),
			}
		);
	};

	if (asChild) {
		// Merge padding classes into the direct child, avoid extra wrapper
		if (React.isValidElement(children)) {
			return (
				<LayoutGap
					gap={gap}
					asChild>
					{cloneWithMergedClassName(children as React.ReactElement, classNames)}
				</LayoutGap>
			);
		}
		// Fallback: if child is not an element, wrap once to apply classes
		return (
			<LayoutGap
				gap={gap}
				asChild>
				<div className={classNames}>{children}</div>
			</LayoutGap>
		);
	}

	// Default: use LayoutGap wrapper and apply classes to it
	return (
		<LayoutGap
			gap={gap}
			className={classNames}>
			{children}
		</LayoutGap>
	);
};
